import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SesionStorageService {
  private previousState: { [key: string]: any } = {};
  private interval: any;

  constructor() {
  }


  // Método que se dispara cuando hay cambios en sessionStorage
  onSessionStorageChange() {
    console.log('Se detectaron cambios en sessionStorage');
  }

  // Métodos para interactuar con sessionStorage
  getItemString(key: string) {
    return sessionStorage.getItem(key);
  }

  stringifyItem(key: string, item: any) {
    sessionStorage.setItem(key, JSON.stringify(item));
  }

  parseItem<T>(key: string) {
    return JSON.parse(sessionStorage.getItem(key)) as T;
  }

  setItem(key: string, item: any) {
    sessionStorage.setItem(key, item);
  }

  getItemJSON(key: string) {
    return JSON.parse(sessionStorage.getItem(key));
  }

  removeItem(key: string) {
    sessionStorage.removeItem(key);
  }

  clear() {
    sessionStorage.clear();
  }
}
